import { render, staticRenderFns } from "./produksi_beras.vue?vue&type=template&id=c5b93e82&"
import script from "./produksi_beras.vue?vue&type=script&lang=js&"
export * from "./produksi_beras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports